import type { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';

// Ссылка пропуска навигации: видна только при фокусе с клавиатуры. Фокус переводим сами: якорь `#main` попал бы в адрес
// и сработал как диплинк страницы (например, в карточке компании).
export default function SkipLink() {
  const { t } = useTranslation();

  function handleClick(event: MouseEvent<HTMLAnchorElement>): void {
    event.preventDefault();
    document.getElementById('main')?.focus();
  }

  return (
    <a href="#main" className="skip-link" onClick={handleClick}>
      {t('nav.skipToContent')}
    </a>
  );
}
